const components_styles = {}

export default components_styles
